import { Injectable } from '@angular/core';
import { IsProjectType } from '@project/model/is-project-type';
import { UserModel } from '../model/user.model';
import { ProjectUtils } from '@project/components/project/util/project-utils';
import { ProjectModel } from '@project/model/project.model';

@Injectable({
  providedIn: 'root'
})
export class UserPermissionService {

  constructor(
    private userModel: UserModel,
    private projectModel: ProjectModel,
  ) { }

  public isLocalBackupVisible(): boolean {
    return this.isLocalBackupVisibleImport() || this.isLocalBackupVisibleExport();
  }

  public isLocalBackupVisibleImport(): boolean {
    return this.userModel.checkPermissions(["IMPORT_PROJECTS"]);
  }

  public isLocalBackupVisibleExport(): boolean {
    return this.userModel.checkPermissions(["EXPORT_PROJECTS"]);
  }

  public isLocalBackupEnabledExport(): boolean {
    return !ProjectUtils.isEmptyProject(this.projectModel.currentProject);
  }

  public isProServeImportVisible(): boolean {
    if (!this.isLoggedIn()) return false;
    return this.userModel.user.hasPermissions(["SAVE_PROJECTS", "IMPORT_PROSERVE_PROJECTS"], true);
  }

  public isCAEEnabled(): boolean {
    return this.isCAEEnabledImport() || this.isCAEEnabledExport();
  }

  public isCAEEnabledImport(): boolean {
    return this.isLoggedIn() && this.userModel.checkPermissions(["IMPORT_FROM_CAE"]);
  }

  public isCAEEnabledExport(): boolean {
    return this.isLoggedIn() && this.userModel.checkPermissions(["EXPORT_TO_CAE"]);
  }

  public isCAEVisible(): boolean {
    return this.isCAEVisibleImport() || this.isCAEVisibleExport();
  }

  private isCAEVisibleImport(): boolean {
    if (!this.isLoggedIn()) {
      return false;
    }
    if (!this.userModel.checkPermissions(["IMPORT_FROM_CAE"])) {
      return false;
    }
    if (!this.projectModel.currentProject) {
      return false;
    }
    return !IsProjectType.among(this.projectModel.currentProject, 'MCS', 'GDS', 'MARKINGSYSTEM');
  }

  private isCAEVisibleExport(): boolean {
    if (this.isLoggedIn() && !this.userModel.checkPermissions(["EXPORT_TO_CAE"])) {
      return false;
    }
    if (!this.projectModel.currentProject) {
      return false;
    }
    return !IsProjectType.among(this.projectModel.currentProject, 'MCS', 'GDS', 'MARKINGSYSTEM');
  }

  public isLoggedIn(): boolean {
    const profile = this.userModel.userProfile;
    return profile && profile.isRegisteredUserAccount();
  }

  public isNumberMappingsVisible(): boolean {
    return this.userModel.checkPermissions(["GET_LIST_OF_ARTICLE_NUMBER_MAPPINGS"]);
  }

  public isSettingsEnabled(): boolean {
    return this.isNumberMappingsVisible() || this.userModel.checkPermissions(["VIEW_FAVORITE_ARTICLES"]);
  }

  public isExportToWSIXVisible(): boolean {
    return (
      IsProjectType.markingSystem(this.projectModel.currentProjectType)
      && this.userModel.user.hasPermission("EXPORT_TO_WSIX"));
  }

  public isExportToWSCXVisible(): boolean {
    return (IsProjectType.markingSystem(this.projectModel.currentProjectType)
      && (this.userModel.isGuestUser() || this.userModel.user.hasPermission("EXPORT_TO_WSCX"))
    );
  }

  public hasIoAssistantPermission(): boolean {
    return this.userModel.user.hasPermission('VIEW_IO_ASSISTANT');
  }
}
